module.exports = __webpack_public_path__ + "static/media/reformer2.3f53bd07.jpg";